<template>
  <!-- 设计室卡片组件 -->
  <div class="course-card">
    <router-link class="course-link" :to="{name: 'studioDetail', params: {id: item.id}}">
      <div class="course-cover background-logo">
        <img class="cover-image" src="" v-lazy="item.thumb">
      </div>
      <div class="course-info">
        <div class="course-title">
          <div class="title">{{item.title}}</div>
          <div class="course-status">
            <span class="signing" v-if="item.status == 1 && enrollEndSoon">即将报名截止</span>
            <span class="signing" v-else-if="item.status == 1">报名中...</span>
            <span class="ing" v-else-if="item.status == 2">进行中...</span>
          </div>
        </div>
        <!-- 特殊设计室不显示此模块 -->
        <div class="studio-info" v-if="!isSpecialStudio">
          <div class="teacher-name">{{item.teacher_name}}</div>
          <div class="course-date" v-if="item.status == 1">报名截止：{{formatEnrollEnd}}</div>
          <div class="course-date" v-else-if="item.status == 3">已结束</div>
        </div>
      </div>
    </router-link>
  </div>

</template>

<style lang="less" scoped></style>

<script>
  import Utils from '@/untils/utils'
  export default {
    props: {
      item: {
        type: Object,
        default: {}
      }
    },
    computed: {
      enrollEndSoon() {
        // 距离报名截止日期48小时之前，报名即将截止
        const enrollWillEnd = this.item.enroll_end - new Date().getTime() / 1000;
        if (enrollWillEnd <= (60 * 60 * 24 * 2) && enrollWillEnd > 0) {
          return true;
        }else {
          return false;
        }
      },
      formatEnrollEnd() {
        // 格式化报名截止时间
        const enrollEndTime = this.item.enroll_end * 1000;
        return `${Utils.formatTimeToDay(new Date(enrollEndTime))}`
      },
      // 是否为特殊设计室
      isSpecialStudio() {
        const idList = [129, 132];
        return idList.includes(parseInt(this.item.id));
      }
    },
    data() {
      return {}
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Course/Cards/studioCard.vue